import React, { useEffect } from 'react';
import { Box } from 'edenred-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';

import { getCompanyInfo } from '@epi-selectors/companyAccounts';
import { FormFields } from '@epi-forms/helpers/controlsHelper';
import {
  EInvoice,
  OperatorField,
  EInvoiceAddressField
} from '@epi-forms/controls/EInvoice';
import { getUserCompany } from '@epi-actions/api';

export const InvoiceForm = () => {
  const { eInvoiceAddress, operator } = useSelector(getCompanyInfo);
  const { setValue, watch, clearErrors } = useFormContext();
  const paymentMethod = watch(FormFields.PaymentMethod);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserCompany());
  }, []);

  useEffect(() => {
    clearErrors([FormFields.EInvoiceAddress, FormFields.EInvoiceOperator]);
  }, [paymentMethod]);

  useEffect(() => {
    setValue(FormFields.EInvoiceAddress, eInvoiceAddress);
    setValue(FormFields.EInvoiceOperator, operator);
  }, [eInvoiceAddress, operator]);

  return (
    <Box display="flex" gap={1} mb={1}>
      <EInvoice>
        <EInvoiceAddressField readOnly />
        <OperatorField readOnly />
      </EInvoice>
    </Box>
  );
};
